export type Values = Record<string, any>

interface Handler<Request = Values, Result = Values> {
  setNext(handler: Handler<Request, Result>): Handler<Request, Result>

  handle(request: Request): Result
}

export abstract class PayloadHandler implements Handler {
  private nextHandler?: Handler

  public setNext(handler: Handler): Handler {
    this.nextHandler = handler

    return handler
  }

  public handle(request: Values): Values {
    if (this.nextHandler) {
      return this.nextHandler.handle(request)
    }

    return request
  }
}
